import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminTrainingParticipants from './AdminTrainingParticipants';

export default withRequiredAdmin(AdminTrainingParticipants);
